export default "/images/VuMedi.png?10cc1f096da36571ed0b232cfd0e0ebe";